module.exports = __webpack_public_path__ + "img/53_32.baf5300b.png";